module.exports = __webpack_public_path__ + "img/9788949123059.7c45ed88.jpg";